var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex-level" }, [
    _vm.color != ""
      ? _c("div", {
          staticClass: "chip label-chip",
          class: [_vm.gapMapping],
          style: { backgroundColor: "" + _vm.color }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "flex label-value",
      domProps: { innerHTML: _vm._s(_vm.label) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }